import { useParams } from 'react-router-dom';
import useAuth from '@/modules/auth/hooks/useAuth.hook';
import { useGetDefaultPage, useGetPage, useGetPageUsernames } from '@linkie/shared';
import { isPublicPageRoute } from '@/core/utils/is-public-page-route';

export const useDefaultPageQuery = () => {
  const { state: authState } = useAuth();

  return useGetDefaultPage(authState.user?._id ?? '', {
    queryConfig: {
      enabled: authState.isAuthenticated && !isPublicPageRoute(),
    },
  });
};

export const usePageUsernamesQuery = () => {
  const { state: authState } = useAuth();

  return useGetPageUsernames(authState.user?._id ?? '', {
    queryConfig: {
      enabled: authState.isAuthenticated && !isPublicPageRoute(),
    },
  });
};

export const usePageQuery = () => {
  const params = useParams();

  return useGetPage(
    {
      username: params.username,
      domain: window.location.host,
    },
    {
      // `isPublicPageRoute()` — not `isPreviewRoute()` — so a custom domain root
      // ("/", which no `/:username` pattern can match) actually looks its page
      // up. Without it the query stays disabled and an unmapped domain renders
      // the empty initial payload as if it were a real page.
      queryConfig: {
        enabled: (!!params.username || !!window.location.host) && isPublicPageRoute(),
        retry: false,
      },
    },
  );
};
